import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SensorNotificationBatteryAlert from '@/components/OperationOfficeForms/SensorNotificationBatteryAlert.vue';
import getOperationOfficeResponse from "@/types/responses/getOperationOffice"
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorAlertSettings',
  props: {
    modelValue: {},
    windowInnerWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SensorNotificationBatteryAlert, {
    class: "mb-6",
    modelValue: modelValue.value.sensor_notification_battery_level,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.sensor_notification_battery_level) = $event)),
    windowInnerWidth: props.windowInnerWidth
  }, null, 8, ["modelValue", "windowInnerWidth"]))
}
}

})